export default function findAddress(position, callback){
    var lat = position.coords.latitude;
    var long = position.coords.longitude;
    var url = "https://maps.googleapis.com/maps/api/geocode/json?latlng=" + lat + "," + long + "&key=AIzaSyD2CUeK2bhXw_En1VXdPhYRgrB0mHqmW7c";
    let location = fetch(url).then(results=>{
      return results.json()
    }).then(json=>{
     callback(json); 
    });
  }